import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import Button from 'Components/Atoms/Button/Button';
import Container from 'Components/Atoms/Container/Container';
import DotBtnItem from 'Components/Atoms/DotBtnItem/DotBtnItem';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import Title from 'Components/Atoms/Title/Title';
import { UserBlocked } from 'Components/Atoms/UserManagement/UserBlocked';
import Field from 'Components/Organisms/Field/Field';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { fetchAllScopes } from 'Store/Api/Actions';
import { getAllScopes } from 'Store/Api/Selectors';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { StoreState } from 'Store/Reducers';
import { addUserPermission, blockUser, deleteUserPermission, fetchUserPermissions, resetUserPermission, saveUserPermissions, unblockUser, updateUser } from 'Store/User/Actions';
import { isUserPatching } from 'Store/User/Selectors';
import { convertTimestampToDateAndTime } from '../../../Services/Date/Date';
import { UserCreation } from '../../Atoms/UserManagement/UserCreate';
import { UserEmail } from '../../Atoms/UserManagement/UserEmail';
import { UserLogin } from '../../Atoms/UserManagement/UserLogin';
import { UserName } from '../../Atoms/UserManagement/UserName';
import ButtonGroup from '../ButtonGroup/ButtonGroup';
import { DotBtn } from '../DotBtn/DotBtn';
import FormGroup from '../Form/FormGroup/FormGroup';
import Modal from '../Modals/Modal/Modal';
import ModalFooter from '../Modals/ModalFooter/ModalFooter';
import ModalHeader from '../Modals/ModalHeader/ModalHeader';

const UserManagementItem = ({
    user,
    isBlocked,

    isPatching,

    ...props
}: UserManagementItemProps) => {
    const [isEditModalOpen, setEditModalOpen] = useState(false);
    const initialState = {
        roles: user?.roles?.map(i => i.name) ?? []
    }
    const [data, setData] = useState(initialState);

    const handleEditModal = () => {
        setEditModalOpen(!isEditModalOpen);
        if (!isEditModalOpen) {
            setData(initialState);
        }
    };

    const handleSave = () => props.updateUser(user.user_id, data);

    const handleChange = (key: string) => (value: any) => setData((data) => ({
        ...data,
        [key]: value
    }));

    useEffect(() => {
        if (!isPatching && isEditModalOpen) handleEditModal();  
    }, [isPatching]);

    return <div className={`user-item ${isBlocked ? 'blocked' : ''}`}>
        <div className={'user-item__header'}>
            <img src={user?.picture} className={'user-initials'} />
            <div className={'user-item__header-toolbox'}>
                { isBlocked && <UserBlocked /> }
                <DotBtn>
                    <DotBtnItem name={'Aanpassen'} onClick={handleEditModal}/>
                    { !isBlocked && <DotBtnItem name={'Block'} css={'warning'} onClick={() => props.blockUser(user.user_id)} /> }
                    { isBlocked && <DotBtnItem name={'Unblock'} css={'warning'} onClick={() => props.unblockUser(user.user_id)} /> }
                </DotBtn>
            </div>
        </div>
        <UserName name={user.name}/>
        <UserEmail email={user.email} />
        <div className={'user-item__info'}>
            <Field
                isEdit={false}
                value={user.roles?.map(i => i?.name)}
                onChange={handleChange('roles')}
                type={FieldType.MultiSelect}
                properties={{
                    list: [{
                        label: 'Admin',
                        value: 'ADMIN'
                    }, {
                        label: 'Gebruiker',
                        value: 'USER'
                    }] 
                }}
            />
        </div>
        <UserLogin login={convertTimestampToDateAndTime(user.last_login)}/>
        <UserCreation creation={convertTimestampToDateAndTime(user.created_at)}/>

        {
            isEditModalOpen &&
            <Modal size='small'>
                <ModalHeader
                    actions={
                        <Button
                            variant='transparent'
                            color='dark'
                            size='medium'
                            onClick={handleEditModal}
                            iconBefore={<FontAwesomeIcon icon={faXmark} />}
                        />
                    }
                >
                    <Title
                        size='large'
                        weight='bold'
                    >
                        Gebruiker aanpassen
                    </Title>
                </ModalHeader>
                <Container padding='vertical'>
                    <FormGroup title='Rol'>
                        <Field
                            isEdit={true}
                            value={data?.roles}
                            onChange={handleChange('roles')}
                            type={FieldType.MultiSelect}
                            properties={{
                                list: [{
                                    label: 'Admin',
                                    value: 'ADMIN'
                                }, {
                                    label: 'Gebruiker',
                                    value: 'USER'
                                }] 
                            }}
                        />
                    </FormGroup>
                    <FormGroup title='Importeer e-mails'>
                        -
                    </FormGroup>
                </Container>
                <ModalFooter>
                    <ButtonGroup>
                        <Button
                            variant="transparent"
                            onClick={handleEditModal}
                        >
                            Annuleren
                        </Button>
                        <Button
                            color="primary"
                            variant="solid"
                            onClick={handleSave}
                            isLoading={isPatching}
                        >
                            Aanpassen
                        </Button>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        }
    </div>
}

interface Props {
    user?: any
    isBlocked?: any
}

const mapState = (state: StoreState, props: Props) => ({
    isPatching: isUserPatching(state)
});

const mapDispatch = {
    updateUser,
        
    blockUser,
    unblockUser,
    fetchAllScopes,
    fetchUserPermissions,
    addUserPermission,
    deleteUserPermission,
    resetUserPermission,
    saveUserPermissions
};

type UserManagementItemProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(UserManagementItem);